export const ITEM_POSITIONS: any[] = [
  { name: 'top-left', label: 'Top Left' },
  { name: 'top-right', label: 'Top Right' },
  { name: 'bottom-left', label: 'Bottom Left' },
  { name: 'bottom-right', label: 'Bottom Right' },
];

export const MAP_STYLES: any[] = [
  { name: 'mapbox://styles/mapbox/streets-v12', label: 'Streets' },
  { name: 'mapbox://styles/mapbox/outdoors-v12', label: 'Outdoors' },
  { name: 'mapbox://styles/mapbox/light-v11', label: 'Light' },
  { name: 'mapbox://styles/mapbox/dark-v11', label: 'Dark' },
  { name: 'mapbox://styles/mapbox/satellite-v9', label: 'Satellite' },
  { name: 'mapbox://styles/mapbox/satellite-streets-v12', label: 'Satellite Streets' },
];

export const MAP_COUNTRIES: any[] = [
  { name: 'NG', label: 'Nigeria' },
  { name: 'NM', label: 'Namibia' },
  { name: 'ZA', label: 'South Africa' },
  { name: 'ZW', label: 'Zimbabwe' },
  { name: 'ZM', label: 'Zambia' },
];
